export default function PageTitle({ title, size = "s" }: { title: string | React.ReactNode; size?: "s" | "m" }) {
  return (
    <div className="whitespace-nowrap text-lg tracking-tighter my-text-border-primary-25 font-bold" data-size={size}>
      {title}
    </div>
  );
}
